var map = {
	"./add.svg": 342,
	"./add_queue.svg": 343,
	"./album.svg": 344,
	"./archive.svg": 345,
	"./audio_file.svg": 346,
	"./bell.svg": 347,
	"./blue_dot_icon.svg": 348,
	"./caret_down.svg": 349,
	"./caret_up.svg": 350,
	"./cart.svg": 351,
	"./check.svg": 352,
	"./circle-minus.svg": 353,
	"./close.svg": 354,
	"./cloud-upload.svg": 355,
	"./collection.svg": 356,
	"./copy.svg": 357,
	"./delete.svg": 358,
	"./download.svg": 359,
	"./edit.svg": 360,
	"./editor_admin.svg": 361,
	"./expand_collapse.svg": 362,
	"./favorite.svg": 363,
	"./folder-open.svg": 364,
	"./genre.svg": 365,
	"./info_panel.svg": 366,
	"./info_round.svg": 367,
	"./init_editor.svg": 368,
	"./instrument.svg": 369,
	"./link.svg": 370,
	"./list-plus.svg": 371,
	"./log-out.svg": 372,
	"./menu.svg": 373,
	"./natural_language.svg": 374,
	"./now_playing.svg": 375,
	"./open_editor.svg": 376,
	"./pause.svg": 377,
	"./playlist_reorder.svg": 378,
	"./playlists.svg": 379,
	"./queue.svg": 380,
	"./quick_filter.svg": 381,
	"./radio.svg": 382,
	"./receipt.svg": 383,
	"./remove.svg": 384,
	"./rotate-cw.svg": 385,
	"./save-all.svg": 386,
	"./save.svg": 387,
	"./scroll-text.svg": 388,
	"./search.svg": 389,
	"./settings.svg": 390,
	"./share_add_person.svg": 391,
	"./share_copy_link.svg": 392,
	"./similar_tracks.svg": 393,
	"./sort.svg": 394,
	"./split.svg": 395,
	"./tag.svg": 396,
	"./text_search.svg": 397,
	"./track.svg": 398,
	"./triangle-alert.svg": 399,
	"./triangle.svg": 400,
	"./upload.svg": 401,
	"./user-minus.svg": 402,
	"./user-shield.svg": 403,
	"./variation.svg": 404,
	"./volume.svg": 405,
	"./volume_muted.svg": 406
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 906;